var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"md":"12","xs":"12","sm":"12"}},[_c('router-view')],1)],1)],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }